/**
 * The Help Center's sections, in the order the home page shows them. Each
 * section is written by one SI leader (authors.js), matched to the part of
 * the business they lead.
 *
 * `icon` names a lucide-react icon; `flag` hides a section until its feature
 * is live (flags.js).
 */
export const HELP_SECTIONS = Object.freeze([
  {
    id: 'getting-started',
    title: 'Getting started',
    description: 'What Defera is, how it works and whether it fits your trip.',
    icon: 'Compass',
    author: 'iris',
  },
  {
    id: 'booking',
    title: 'Booking a trip',
    description: 'Finding flights, choosing a plan and what happens at checkout.',
    icon: 'Plane',
    author: 'iris',
  },
  {
    id: 'payments',
    title: 'Payments & your schedule',
    description: 'Installments, due dates, paying ahead and your card on file.',
    icon: 'CalendarClock',
    author: 'bernard',
  },
  {
    id: 'missed-payments',
    title: 'Missed payments',
    description: 'What happens when a payment doesn’t go through, and how to get back on track.',
    icon: 'LifeBuoy',
    author: 'audrey',
  },
  {
    id: 'changes-cancellations',
    title: 'Changes, cancellations & credit',
    description: 'Changing a flight, cancelling a trip and using Defera Credit.',
    icon: 'RefreshCcw',
    author: 'owen',
  },
  {
    id: 'confirmation-and-travel',
    title: 'Your confirmation & travel day',
    description: 'When your confirmation number arrives and getting ready to fly.',
    icon: 'PlaneTakeoff',
    author: 'owen',
  },
  {
    id: 'seats-and-bags',
    title: 'Seats, bags & upgrades',
    description: 'Choosing seats, adding bags and how upgrades work.',
    icon: 'Armchair',
    author: 'owen',
  },
  {
    id: 'flight-and-hotel',
    title: 'Flight + Hotel',
    description: 'Booking a hotel with your flight and finding your stay details.',
    icon: 'BedDouble',
    author: 'owen',
  },
  {
    id: 'travel-insurance',
    title: 'Travel insurance',
    description: 'Travel insurance from Faye: what’s offered, adding it and claims.',
    icon: 'ShieldCheck',
    author: 'elliott',
    flag: 'faye',
  },
  {
    id: 'rewards',
    title: 'Miles & rewards',
    description: 'Earning Defera Miles, using them on a trip and gift cards.',
    icon: 'Sparkles',
    author: 'miles',
  },
  {
    id: 'account',
    title: 'Account, security & privacy',
    description: 'Signing in, your profile and travelers, and keeping your account safe.',
    icon: 'UserRound',
    author: 'silas',
  },
  {
    id: 'emails',
    title: 'Emails & notifications',
    description: 'The emails we send, what they mean and how to manage them.',
    icon: 'Mail',
    author: 'margot',
  },
  {
    id: 'contact',
    title: 'Contacting Defera',
    description: 'Chat, phone and email, and how requests to our team work.',
    icon: 'MessageCircle',
    author: 'stephanie',
  },
]);

export const SECTION_IDS = Object.freeze(HELP_SECTIONS.map((s) => s.id));
